module.exports = __webpack_public_path__ + "img/A1_8.17b9ea32.jpg";